import React, { useState } from "react";
import { IMaskInput } from "react-imask";

/**
 * Маска российского телефона: +7 (XXX) XXX-XX-XX.
 *  - всегда показывает шаблон (lazy=false);
 *  - корректно обрабатывает вставку номеров, начинающихся с 8 или 7 (срезает ведущую цифру);
 *  - сообщает родителю о полноте номера через onValidityChange(isComplete);
 *  - при потере фокуса с неполным номером показывает аккуратный текст ошибки.
 */
const PhoneInput = React.forwardRef(({
  value,
  onChange,
  onValidityChange,
  placeholder = "+7 (___) ___-__-__",
  className = "field-input",
  ...rest
}, ref) => {
  const [touched, setTouched] = useState(false);
  const [complete, setComplete] = useState(false);

  // Если пользователь вставляет/начинает ввод с 7 или 8 в первой позиции — отбрасываем её,
  // т.к. префикс +7 уже зафиксирован маской.
  const prepare = (str, masked) => {
    if (masked.value.length === 0) {
      return str.replace(/^[78]+/, "");
    }
    return str;
  };

  const handleAccept = (val, mask) => {
    const isComplete = Boolean(mask?.masked?.isComplete);
    setComplete(isComplete);
    onChange?.({ target: { value: val } });
    onValidityChange?.(isComplete);
  };

  const showError = touched && !complete && (value || "").length > 0;

  return (
    <div className="w-full">
      <IMaskInput
        mask="+{7} (000) 000-00-00"
        lazy={false}
        overwrite="shift"
        prepare={prepare}
        value={value}
        onAccept={handleAccept}
        onBlur={() => setTouched(true)}
        placeholder={placeholder}
        className={className}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        inputRef={ref}
        aria-invalid={showError || undefined}
        {...rest}
      />
      {showError && (
        <p
          className="mt-1 text-xs"
          style={{ color: "var(--color-primary)" }}
          data-testid="phone-error"
        >
          Введите номер полностью: +7 и 10 цифр
        </p>
      )}
    </div>
  );
});

PhoneInput.displayName = "PhoneInput";
export default PhoneInput;
